
//import firebase from 'firebase'
//import 'firebase/firestore'
import firebase from 'firebase'
import { firestore } from '@firebase/firestore';

// firebase init goes here
const config = {
   apiKey: String(process.env.apiKey),
   authDomain: String(process.env.authDomain),
   databaseURL: String(process.env.databaseURL),
   projectId: String(process.env.projectId)
}
//firebase.initializeApp(config)
if (!firebase.apps.length) {
	firebase.initializeApp(config)
}

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
    timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
/*const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')*/ 

export {
    db,
    auth,
    currentUser
}


// WEBPACK FOOTER //
// ./src/firebaseConfig.js